// extracted by mini-css-extract-plugin
module.exports = {"process":"CSProcess_process__9QD8n","wheel":"CSProcess_wheel__kIodU","spin":"CSProcess_spin__1HHq7","content":"CSProcess_content__3gZ1L"};